'use client';

import { type ComponentProps } from 'react';
import dynamic from 'next/dynamic';
import { AppDownloadTrigger, Section, Spacing } from '~/components';
import { useEnvironmentInfo } from '~/hooks';

import { Divider } from '@bgzt/ui';
import { goToFullWebviewOnApp } from '~/services/app-interface';
import styles from './Guide.module.scss';

const BunjangContentViewer = dynamic(() => import('@bgzt/cms').then((m) => m.BunjangContentViewer), { ssr: false });

export const Guide = () => {
  const { deviceType, isWebview } = useEnvironmentInfo();

  const cmsViewerProps: Omit<ComponentProps<typeof BunjangContentViewer>, 'pathName'> = {
    osType: deviceType,
    onItemClick: (link) => {
      // 웹뷰 아닌 환경에서는 이동을 막는다
      if (!isWebview) return;
      if (!link) return;

      goToFullWebviewOnApp({ url: link.value }).go();
    },
  };

  return (
    <AppDownloadTrigger requiredClassName="link">
      <div className={styles.wrapper}>
        {/* // TODO: 우선은여기서 스크롤을 막기 위해 스타일을 넣어주고 있지만, 
      추후에 BunjangContentViewer에서 스크롤을 막거나 style prop을 받을 수 있도록 수정 필요 */}
        <Section className={styles.cmsWrapper} fullWidth>
          <BunjangContentViewer pathName="mercari_guidetab" {...cmsViewerProps} />
        </Section>

        <Divider thickness={10} />

        <Section className={styles.cmsWrapper} fullWidth>
          <BunjangContentViewer pathName="mercari_item_Faq_full" {...cmsViewerProps} />
        </Section>

        <Spacing height={40} />
      </div>
    </AppDownloadTrigger>
  );
};
